<template>
  <AdminLayout :title="$t('admin_subscription.subscription_title')" :current="$c.ADMIN.TAB.ACCEPT">
    <div class="section">
      <div class="container wrap">
        <div class="border item" v-for="item in userList">
          <div class="part">
            <img width="100%" height="100%" :src="item.f_business_card" @click="show_img(item.f_business_card)"/>
          </div>
          <div class="part" style="padding: 0.3em;">
            <div class="atom phone_label" v-html="format(item.f_phone)">{{}}</div>
            <div class="atom">
              <div class="box" v-html="state.f_answer_status === 'Y' ?'O':'X'" v-for="(state , i) in item.answer_list" :key="i"></div>
              <div class="box" v-if="item.answer_list.length === 0" v-for="i in 3" :key="i">X</div>
            </div>
            <div class="atom" style="justify-content: space-between; align-items:flex-end;height: 34%">
              <b-button class="reject_btn" squared  @click="reject(item.f_phone, item.f_idx)">{{$t('admin_subscription.reject')}}</b-button>
              <b-button class="approve_btn" squared  @click="approve(item.f_phone, item.f_idx)">{{$t('admin_subscription.approve')}}</b-button>
            </div>
          </div>
        </div>
        <p class="p-center" v-if="userList.length === 0">{{$t('common.empty_hint')}}</p>
      </div>
    </div>
    <Gallery :src="md_img" :visible.sync='showGallery'></Gallery>
  </AdminLayout>
</template>
<script>
import AdminLayout from './controls/adminlayout'
import InputSearch from './controls/input_search'
import Gallery from "../../../controls/Gallery";
import Utils from "../../../../config/utils";

export default {
  name: "AdminAccept",
  components: {
    AdminLayout,
    InputSearch,
    Gallery
  },
  data() {
    return {
      md_img:[],
      loadEnd:false,
      userList:[],
      showGallery:false,
    }
  },
  methods:{
    show_img(src){
      this.md_img = [src];
      this.showGallery = true;
    },
    format(val){
      return Utils.formatPhoneNumber(val);
    },
    reject(phone,userId){
      Utils.showConfirm(this, phone + "<br>"+ this.$t('admin_subscription.confirm_reject')).then(
        value => {
          if(value){
            Utils.requestPost(this.$c.API.User.changeUserStatusById, {
              user_id: userId,
              status: 'R'
            }).then((result) => {
              if (result.code === this.$c.API_RES_CODE.SUCCESS) {
                this.getPendingUserList(true);
                Utils.toast(this, this.$t('admin_subscription.rejected'));

              }
            });
          }
        }
      )
    },
    approve(phone, userId){
      Utils.requestPost(this.$c.API.User.changeUserStatusById, {
        user_id: userId,
        status: 'A'
      }).then((result) => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
          this.getPendingUserList(true);
          Utils.toast(this, this.$t('admin_subscription.approved'));

        }
      });
    },
    handleUserListData(clear, result) {
      if (result.code === this.$c.API_RES_CODE.SUCCESS) {
        this.loadEnd = result.data.list.length < this.$c.PAGE_COUNT;
        this.userList = clear ? [].concat(result.data.list)
          : this.userList.concat(result.data.list);
      } else {
        Utils.toast(this, result.msg);
        this.loadEnd = true;
      }
      // this.setState({loading: false});
    },

    getPendingUserList(clear = false) {
      if (!clear && this.loadEnd) {
        return;
      }
      Utils.requestGet(this.$c.API.User.getPendingUserList, {
        offset: clear ? 0 : this.userList.length,
        limit: this.$c.PAGE_COUNT
      }).then((result) => {
        this.handleUserListData(clear, result);
      });
    },
    },
  mounted() {
    this.getPendingUserList();
  }

}
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/main/admin/Admin.scss';
.item{
  margin-bottom: 1em;
  height: 7em;
  width:48%;
  display: flex;
  justify-content: space-between;
}
.part{
  width: 49%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.atom{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 33%;
  width: 100%;
}

.box{
  @extend .phone_label;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin-right: 3px;
  background: #f0f1f2;
  border:solid 1px #e7e5e5;
}

.reject_btn{
  height: 29px;
  width: 60px;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: $fs_14;
  font-family: $korean_gd_15_r;
  padding: 0;
  background-color: #848484;
}

.approve_btn{
@extend .reject_btn;
  background-color: #267fff;
}

.container{
  padding-top: 1em;
}

.phone_label{
  color: black;
  font-size:$fs_16;
  font-family: $korean_gd_13_r;
}

.wrap{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/AdminAccept.vue